export const APP_CONFIG = {
    IS_RIGHTS_ISSUE_CLOSED: true // Set to true to close the Rights Issue
};
